export const CONFIG = {
    uri: 'https://ecommcer-kawishop-1234.ue.r.appspot.com',
    //uri: 'http://localhost:4000',
}